import { GAME_MODES, GAME_SCENE } from '../../core/constats';
import { gamePadMobileLandScapeDrawer } from './drawers/GamePadMobileLandScapeDrawer';
import { gamePadMobileDrawer } from './drawers/GamePadMobileDrawer';
import { GamePadDesktopDrawer } from './drawers/GamePadDesktopDrawer';
import { gamePadLocaleState } from './state';
import { BaseParentControlDrawer } from '../../core/abstraction/BaseParentControlDrawer';
import { spinButtonHelper } from '../../services/helperService/SpinButtonHelper';
import { CANVAS_GAME_LOADED, GAME_SCENE_STATE, LOADING_STATE, SPIN_AMOUNT } from '../../stateManagment/gameState';
import { autoSpinHelper } from '../../services/helperService/AutoSpinHelper';
import { popupHelper } from '../../services/helperService/PopupHelper';
import { bigWinService } from '../../services/helperService/BigWinService';
import { bigWinAnimationDrawer } from '../bigWinAnimation/BigWinAnimationDrawer';
import { debounce } from '../../core/helpers/debounce';

class GamePadDrawer extends BaseParentControlDrawer {
  constructor(applications) {
    super(applications);
    gamePadLocaleState.betButtonActive.subscribe(bool => {
      if (bool && gamePadLocaleState.autoSpinButtonActive.getValue()) {
        gamePadLocaleState.autoSpinButtonActive.next(false);
      }
    });
    gamePadLocaleState.autoSpinButtonActive.subscribe(bool => {
      if (bool && gamePadLocaleState.betButtonActive.getValue()) {
        gamePadLocaleState.betButtonActive.next(false);
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Space' && CANVAS_GAME_LOADED.getValue() && !LOADING_STATE.getValue()) {
          this._onCLick();
        }
      },
    );
  }

  _onCLick = debounce(() => {
    switch (GAME_SCENE_STATE.getValue()) {
      case GAME_SCENE.MAIN:
        if (popupHelper.checkAndClosePopups()) {
          return;
        }
        if (bigWinService.state) {
          bigWinAnimationDrawer.application.onClick();
          return;
        }
        if (!spinButtonHelper.active) {
          return;
        }
        if (autoSpinHelper.autoSpinActive) {
          this.application.handleAutoSpinButtonClick()();
        } else {
          this.application.animateSpinButton();
          this.application.handleSpinButtonClick()();
        }
        return;
      case GAME_SCENE.PRE_BONUS:
        if (!spinButtonHelper.active) {
          return;
        }
        // this.application.animateSpinButton();
        // this.application.handlePreBonusSpinButtonClick()();
        return;
      case GAME_SCENE.BONUS:
        if (popupHelper.checkAndClosePopups()) {
          return;
        }
        if (bigWinService.state) {
          bigWinAnimationDrawer.application.onClick();
          return;
        }
        if (!spinButtonHelper.active) {
          return;
        }
        this.application.handleBonusClick();
        return;
      default:
        return;
    }
  }, 250, true)

  resetOpenedState() {
    gamePadLocaleState.betButtonActive.next(false);
    gamePadLocaleState.autoSpinButtonActive.next(false);
  }

  execute(mode, config = {}) {
    return super.execute(mode, config);
  }
}

export const gamePadDrawer = new GamePadDrawer({
  [GAME_MODES.MOBILE_LANDSCAPE]: gamePadMobileLandScapeDrawer,
  [GAME_MODES.MOBILE]: gamePadMobileDrawer,
  [GAME_MODES.DESKTOP]: new GamePadDesktopDrawer(),
});
